<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("listaDeOS") }}
        </h1>
      </div>
    </div>
    <VisionOneTable />
  </div>
</template>

<script>
import VisionOneTable from './components/VisionOneTable.vue';

export default {
  components: { VisionOneTable },
};
</script>
